var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_vm._t("default")],2),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"accent","depressed":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('close')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }